import { getColor, Theme, createStyles } from '@bb-ui/react-library/dist/components/styles';

// TODO: nav toggle for small breakpoint
export const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'grid',
      overflow: 'hidden',
      // TODO: (after nav toggle) remove navigation
      gridTemplateAreas: `"sidebar header"
                        "sidebar page-header"
                        "sidebar main"`,
      // Header height reduced from 48px to 44px
      gridTemplateRows: `44px
                       auto
                       1fr`,
      gridTemplateColumns: '240px 1fr',
      [theme.breakpoints.up('md')]: {
        gridTemplateAreas: `"sidebar header"
                          "sidebar page-header"
                          "sidebar main"`,
        // Header height reduced from 48px to 44px
        gridTemplateRows: `44px
                         auto
                         1fr`,
        gridTemplateColumns: '240px 1fr',
      },
      backgroundColor: getColor('background.b3', theme),
      transition: 'top 0.2s ease, height 0.2s ease',
    },
    rootClassic: {
      position: 'fixed',
      width: '100%',
      height: '100%',
      display: 'grid',
      justifyContent: 'center',
      overflowY: 'auto',
      overflowX: 'hidden',
      gridTemplateAreas: `"header"
                        "page-header"
                        "main"`,
      gridTemplateRows: `64px
                       auto
                       1fr`,
      gridTemplateColumns: '100%',
      [theme.breakpoints.up('md')]: {
        gridTemplateAreas: `"header"
                          "page-header"
                          "main"`,
        gridTemplateRows: `64px
                         206px
                         1fr`,
        gridTemplateColumns: '1fr',
      },
      backgroundColor: getColor('background.b3', theme),
      transition: 'top 0.2s ease, height 0.2s ease',
    },
    rootWithBanner: {
      top: '32px',
      height: 'calc(100% - 32px)',
    },
    contentWrap: {
      maxWidth: '1000px',
    },
  });
